const KEY = "cohesive-home-reset";

/**
 * Dev-only switch for the reset control: `?homeReset=1` shows it (persisted
 * in localStorage), `?homeReset=0` hides it. Only under `vite dev`.
 */
export function readHomeResetOverride(): boolean {
  if (!import.meta.env.DEV || typeof window === "undefined") return false;
  try {
    const q = new URLSearchParams(window.location.search).get("homeReset");
    if (q === "1" || q === "true") {
      localStorage.setItem(KEY, "true");
      return true;
    }
    if (q === "0" || q === "false") {
      localStorage.removeItem(KEY);
      return false;
    }
    return localStorage.getItem(KEY) === "true";
  } catch {
    return false;
  }
}
